import { RootState } from 'rootReducer';

export const selectIsVerifyingLinkedInOAuth = (state: RootState) =>
  state.ui.apps.survey.verification.home.isVerifyingLinkedInOAuth;

export const selectIsPostingDetails = (state: RootState) =>
  state.ui.apps.survey.verification.home.isPostingDetails;
